<div class="d-flex align-items-center min-vh-100 bg-auth">
  <div class="container">
    <div class="justify-content-center row">
      <div class="mb-4 col-xl-4 col-md-5 col-12">
        <h1 class="display-4 text-center mb-3" translate>app.sign.in.title</h1>
        <div class="alert alert-success" role="alert" *ngIf="!isEmpty(message)" [innerHTML]="message"></div>

        <div class="form-group mb-4">
          <label class="form-label" for="contact" translate>app.sign.contact</label>
          <input class="form-control" placeholder="{{'app.sign.email-address' | translate}}..."
                 type="text" name="contact" id="contact" [disabled]="loading"
                 [(ngModel)]="auth.contact"
                 [ngClass]="{ 'invalid': submitted && isEmpty(auth.contact) }"/>
          <div class="d-block text-danger" *ngIf="submitted && isEmpty(auth.contact)"
               translate>app.sign.contact.empty
          </div>
        </div>
        <div class="form-group mb-4" *ngIf="!apiService.getParam('type') || apiService.getParam('type') === 'password'">
          <div class="row">
            <div class="col">
              <label class="form-label" for="password" translate>app.sign.password</label>
            </div>
            <div class="col-auto">
              <a class="small text-muted form-text cursor-pointer"
                 (click)="changeType('reset')" translate>app.sign.forgot</a>
            </div>
          </div>
          <div class="input-group-merge input-group">
            <input class="form-control" placeholder="{{'app.sign.password' | translate}}..."
                   type="password" name="password" id="password" [disabled]="loading"
                   [(ngModel)]="auth.password"
                   [ngClass]="{ 'invalid': submitted && isEmpty(auth.password) }"/>
            <span class="input-group-text icon icon24 eye"></span>
          </div>
          <div class="d-block text-danger" *ngIf="submitted && isEmpty(auth.password)"
               translate>app.sign.password.empty
          </div>
        </div>
        <div class="form-group mb-4"
             *ngIf="apiService.getParam('type') === 'otp' || (submitted && apiService.getParam('type') === 'reset')">
          <label class="form-label" for="otp" translate>app.sign.otp</label>
          <input class="form-control" placeholder="{{'app.sign.otp' | translate}}..."
                 type="text" name="otp" id="otp" [disabled]="loading"
                 [(ngModel)]="auth.otp"
                 [ngClass]="{ 'invalid': submitted && isEmpty(auth.otp) }"/>
          <div class="d-block text-danger" *ngIf="submitted && isEmpty(auth.otp)"
               translate>app.sign.otp.empty
          </div>
        </div>
        <div class="mb-4" *ngIf="error">{{ error }}</div>

        <button class="w-100 mb-3 btn btn-primary btn-lg" (click)="sign()"
                [disabled]="loading">{{
            (apiService.getParam('type') === 'reset'? 'app.sign.reset' : 'app.sign.login') | translate
          }}
        </button>
        <button class="w-100 mb-3 btn btn-primary btn-lg" [disabled]="loading"
                *ngIf="!apiService.getParam('type') || apiService.getParam('type') === 'password'"
                (click)="changeType('otp')" translate>
          app.sign.use.otp
        </button>
        <button class="w-100 mb-3 btn btn-primary btn-lg" [disabled]="loading"
                *ngIf="apiService.getParam('type') === 'otp'"
                (click)="changeType()" translate>
          app.sign.use.password
        </button>
        <p class="text-center">
          <small class="text-muted text-center">
            {{ 'app.sign.no.account' | translate }}
            <span *ngIf="apiService.getParam('type') === 'reset'">
              <a routerLink="/sign-in" translate>app.sign.login</a> or
            </span>
            <a routerLink="/sign-up" translate>app.sign.register</a>.
          </small>
        </p>
      </div>
    </div>
  </div>
</div>
